import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import withRoot from 'src/withRoot'
import Navigation from 'components/Navigation'
import Footer from 'components/Footer'
import Alert from 'containers/Alert'
import './index.css'
import 'rc-pagination/assets/index.css'
import 'react-select/dist/react-select.css'
// import 'rc-select/assets/index.css'
import 'react-circular-progressbar/dist/styles.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Layout = ({ children, data }) => {
  const navigationWidth = 1180

  return (
    <Fragment>
      <Helmet
        title={data.site.siteMetadata.siteTitle}
        meta={[
          {
            name: 'description',
            content: data.site.siteMetadata.siteDescription,
          },
        ]}
      />
      <Navigation width={navigationWidth} />
      <div className="spacing-normalizer" />
      {children()}
      <Footer />
      <Alert />
    </Fragment>
  )
}

Layout.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

// eslint-disable-next-line
export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        siteTitle
        siteName
        siteUrl
        siteDescription
      }
    }
  }
`

export default withRoot(Layout)



// WEBPACK FOOTER //
// ./src/layouts/index.js